import React, { useContext, useEffect, useState } from "react";
import Slider from "react-slick";
import axios from "axios";
import { Card } from "react-bootstrap";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { getFileLiveUrl, makeUrl, momentDate } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import EVENT_IMG from "../../assets/img/event.png";
import PsContext from "../../context";
import { Link } from "react-router-dom";

const HomeScrollEvent = () => {
  const [windowSize, setWindowSize] = useState(window.innerWidth);
  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);
  const context = useContext(PsContext);

  useEffect(() => {
    const handleResize = () => setWindowSize(window.innerWidth);
    window.addEventListener("resize", handleResize);
    loadData();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const loadData = () => {
    setDataList([]);
    setLoader(true);
    axios.get(ServiceUrl.LIST_PAGES + "?type=event&limit=6").then((res) => {
      if (res.data.status === "1") {
        setDataList(res.data.data);
      }
      setLoader(false);
    });
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow:
      windowSize < 500 ? 1 : dataList.length > 3 ? 3 : dataList.length,
    slidesToScroll:
      windowSize < 500 ? 1 : dataList.length > 3 ? 3 : dataList.length,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    draggable: true,
    swipe: true,
  };

  const getCard = (item) => (
    <Link to={`/event/${item.id}/${makeUrl(item.title)}`} key={item.id}>
      <div className="event-wrapper px-2">
        <Card className="border-0 shadow-sm h-100 mb-4">
          <Card.Img
            variant="top"
            src={getFileLiveUrl(item.feature_image)}
            style={{ height: "220px", objectFit: "cover" }}
            alt={item.title}
          />
          <Card.Body>
            <h4 className="fw-bold text-black" style={{ fontSize: "18px" }}>
              {item.title.length > 15
                ? item.title.substring(0, 15) + "..."
                : item.title}
            </h4>
            <p
              className="text-muted"
              style={{ fontSize: "13px", fontWeight: "700" }}
            >
              <i class="fas fa-calendar-alt me-2"></i>
              {momentDate(item.active_from_date, "MMM DD, YYYY")}
            </p>
            <p
              className="text-muted"
              style={{ fontSize: "13px", fontWeight: "700" }}
            >
              <i class="fas fa-location-dot me-2"></i>
              DBC College
            </p>
          </Card.Body>
        </Card>
      </div>
    </Link>
  );

  return (
    <section className="py-5">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-5 mb-4 mb-md-0">
            <div className="text-end pe-md-4">
              <h4 className="heading-with-underline-right pb-3">
                Upcoming Events
              </h4>
              <p className="mt-3 pt-3 pb-2">
                <Link
                  to="/events"
                  className="text-white bg-theme px-3 py-2 shadow text-decoration-none"
                  style={{ borderRadius: "3px" }}
                >
                  View All Events
                </Link>
              </p>
            </div>
            <div className="img d-flex justify-content-center">
              <img
                src={EVENT_IMG}
                alt="Don Bosco Event"
                style={{ width: "100%", maxWidth: "400px" }}
              />
            </div>
          </div>
          <div className="col-md-7 mt-4">
            {dataList.length > 0 && (
              <Slider {...settings}>
                {dataList.map((item) => getCard(item))}
              </Slider>
            )}
            <div className="px-5">
              <hr />
              <p className="text-black fw-bolder text-center">
                Stay updated on the latest events and conferences. Discover
                upcoming events & explore the happenings!
              </p>

              <p className="evnt-btn mt-4 text-center">
                <a href="#" className="shadow">
                  To View all Event Photos
                </a>
              </p>
            </div>
          </div>
          <div className="col-md-1"></div>
        </div>
      </div>
    </section>
  );
};

export default HomeScrollEvent;
